import { render, staticRenderFns } from "./eventStudentList.vue?vue&type=template&id=052621d4&scoped=true&"
import script from "./eventStudentList.vue?vue&type=script&lang=js&"
export * from "./eventStudentList.vue?vue&type=script&lang=js&"
import style0 from "./eventStudentList.vue?vue&type=style&index=0&id=052621d4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "052621d4",
  null
  
)

export default component.exports